import { pageHead } from "@app/framework/meta";
import { InvestorToolPage } from "@modules/investor-relations/pages";
import { trans } from "@mongez/localization";
import { MetaFunction } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";

export default function DividendInformation() {
  useLoaderData();

  return (
    <InvestorToolPage translationKey="dividendInformation" toolName="TSR" />
  );
}

export const meta: MetaFunction = () =>
  pageHead({
    title: trans("dividendInformation"),
    appendAppName: true,
  });
